import maps from "google-maps-api";

// Initiate google api.
(async () => {
  window.mapsApi = maps('AIzaSyDn2tH5Mp2r3CJppYaI3Xp44P83jUWIx6U', ['places']);
  window.mapsApi = await mapsApi();

  let dummy_element = document.createElement('div');
  window.placesService = new mapsApi.places.PlacesService(dummy_element);
})();